import React from 'react'
import PropTypes from 'prop-types'
import { Box, Button, Typography } from '@material-ui/core'
import { Plus as PlusIcon } from 'react-feather'

import { Permitted } from 'components'
import constants from 'constants/index'
import useStyles from './styles'

const CLICK_RATE_ALERT_THRESHOLD = 25

const getBannerContent = (indicators) => {
  if (!indicators || indicators.totalCampaigns === 0)
    return constants.phishing.BANNER_CONTENT.noCampaigns
  if ((indicators.clickRate ?? 0) >= CLICK_RATE_ALERT_THRESHOLD)
    return constants.phishing.BANNER_CONTENT.highClickRate
  return constants.phishing.BANNER_CONTENT.default
}

const PhishingBanner = ({ indicators, onNewCampaign }) => {
  const classes = useStyles()
  const { title, subtitle } = getBannerContent(indicators)

  return (
    <Box className={classes.banner}>
      <Box className={classes.textWrapper}>
        <Typography className={classes.title}>{title}</Typography>
        <Typography className={classes.subtitle}>{subtitle}</Typography>
      </Box>
      <Permitted tag={constants.permissions.PHISHING.MANAGE}>
        <Button
          variant="contained"
          startIcon={<PlusIcon size={16} />}
          className={classes.button}
          onClick={onNewCampaign}
        >
          Nova campanha
        </Button>
      </Permitted>
    </Box>
  )
}

PhishingBanner.propTypes = {
  indicators: PropTypes.shape({
    totalCampaigns: PropTypes.number,
    clickRate: PropTypes.number,
  }),
  onNewCampaign: PropTypes.func,
}

export default PhishingBanner
